import { generateFormattedTextJson } from '@mntn-dev/utilities'
import { FormattedTextSchema } from '@mntn-dev/utility-types'

export const getEditorContent = (value: string) => {
  try {
    const json = JSON.parse(value)
    return FormattedTextSchema.parse(json)
  } catch {
    return generateFormattedTextJson(value)
  }
}
